const formatMoney = function (t, e = simply.moneyFormat) {
    /* Shopify Money Format */
    function o(t, e) {
      return void 0 === t ? e : t
    }
    function i(t, e, i, r) {
      if (e = o(e, 2),
        i = o(i, ","),
        r = o(r, "."),
        isNaN(t) || null == t)
        return 0;
      t = (t / 100).toFixed(e);
      var n = t.split(".");
      return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? r + n[1] : "")
    }
    "string" == typeof t && (t = t.replace(".", ""));
    var r = ""
      , n = /\{\{\s*(\w+)\s*\}\}/
      , a = e || this.money_format;
    switch (a.match(n)[1]) {
      case "amount":
        r = i(t, 2);
        break;
      case "amount_no_decimals":
        r = i(t, 0);
        break;
      case "amount_with_comma_separator":
        r = i(t, 2, ".", ",");
        break;
      case "amount_with_space_separator":
        r = i(t, 2, " ", ",");
        break;
      case "amount_with_period_and_space_separator":
        r = i(t, 2, " ", ".");
        break;
      case "amount_no_decimals_with_comma_separator":
        r = i(t, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        r = i(t, 0, " ");
        break;
      case "amount_with_apostrophe_separator":
        r = i(t, 2, "'", ".")
    }
    return a.replace(n, r)
  };

 
const matchBundleProductId = async (pId) => {
  //fetch cart data to check updated prodct quantity
  let cartItem = await getCartData();
  let totalQuantity = 0;
  let calQty;
  let object = cartItem?.items.filter((items, i) => {
    let item = items.item;
    if(pId == item.product_id) {
      calQty = totalQuantity += item.quantity
      let checkItemQtyLimit = calQty >= simply.product_quantity_limit;
      if(checkItemQtyLimit) {
        return true;
      }
    }
  });
  if(object?.length){
    return false;
  }else {
    return true;
  }
}

class ProductUpsell {
  constructor(parent) {
    if (!parent) {
      return;
    }
    this.parent = parent;
    this.formData = {
      items: [],
    };
    this.totalCount = {
      totalCountArr: [],
      total: 0,
    };
    if (window.innerWidth < 768) {
      this.upsellMobileSlider();
    }
    this.upsellCheckbox();
    this.clickEvent();
  }

  upsellMobileSlider = () => {
    let parent = this.parent;
    let upsellSwiper = qs(".upsell-swiper-js", parent);
    upsellSwiper = new Swiper(upsellSwiper, {
      slidesPerView: 2,
      spaceBetween: 10,
      navigation: {
        nextEl: ".upsell-next-arrow-js",
        prevEl: ".upsell-prev-arrow-js",
      },
    });
  };

  updateHtml = () => {
    let that = this;
    let parent = this.parent;
    let upsellProductPrice = qs(".upsell-product-price-js", parent);
    let totalPrice = qs(".total-price-js", parent);
    let mobileTotalPrice = qs(".count-value-js", parent);
    let html = "";
    that.totalCount.totalCountArr?.forEach((item, i) => {
      let icon = qs('.iconPlus-js',parent);
      if (that.totalCount.totalCountArr?.length == i + 1) {
        icon = qs('.iconEqual-js',parent);
      }
      html += `<div class="text-icon">
        <span class="price text-sm-24 bold">${formatMoney(item.price).replace(
          ".00",
          ""
        )}</span>
        <div class="plus-or-equal-sign d-block">
          ${icon.innerHTML}
        </div>
      </div>`;
    });
    upsellProductPrice.innerHTML = html;
    totalPrice.innerHTML = formatMoney(that.totalCount.total).replace(
      ".00",
      ""
    );
    mobileTotalPrice.innerHTML = formatMoney(that.totalCount.total).replace(
      ".00",
      ""
    );
  };

  upsellTotalCount = (checkbox) => {
    let that = this;
    let active = checkbox.classList.contains("active");
    let price = parseInt(checkbox.dataset.price);
    let vId = checkbox.dataset.variantId;
    if (active) {
      that.totalCount.total = that.totalCount.total + price;
      that.formData.items?.push({ id: vId, quantity: 1 });
      that.totalCount.totalCountArr?.push({ vId, price });
    } else {
      that.totalCount.total = that.totalCount.total - price;
      let newFormData = that.formData.items?.filter((item) => item.id !== vId);
      that.formData.items = newFormData;
      let newtotalCount = that.totalCount.totalCountArr?.filter(
        (item) => item.vId !== vId
      );
      that.totalCount.totalCountArr = newtotalCount;
    }
    that.updateHtml();
  };

  upsellCheckbox = () => {
    let that = this;
    let parent = this.parent;
    let checkboxs = qsa(".checkbox-js", parent);
    checkboxs?.forEach((checkbox) => {
      checkbox.addEventListener("click", (e) => {
        checkbox.classList.toggle("active");
        that.upsellTotalCount(checkbox);
      });
      that.upsellTotalCount(checkbox);
    });
  };

  clickEvent = () => {
    let parent = this.parent;
    let addToCartBtn = qs(".quick-add-cart-js", parent);
    if (window.innerWidth < 768) {
      addToCartBtn = qs(".mobile-quick-add-cart-js", parent);
    }
    addToCartBtn?.addEventListener("click", async (e) => {
      let button = e.currentTarget;
      let vItems = this.formData.items;
      if (vItems.length > 0) {

        let getVarintIndex = button?.getAttribute('variant-index').split(',');
        if(getVarintIndex.length > 0 && simply.enable_product_quantity && simply.product_quantity_limit != 0) {
          let variantId = vItems[parseInt(getVarintIndex[0])]
          let pId = button.getAttribute('data-pid');
          const result = await matchBundleProductId(pId);
          if (!result) {
            toastMessage({msg:simply.limit_error_message},true);
            console.log("ID match found, stopping further processing.");
            return false;
          } else {
            console.log("No matching ID found, continue with further processing.");
          }
        }

        button.classList.add("btn-loading");
        window.addToCartFun(this.formData, () => {
          button.classList.remove("btn-loading");
          sideCartUpdate();
        });
      } else {
        toastMessage({
          error: true,
          msg: "select upsell products",
        });
      }
    });
  };
}

new ProductUpsell(qs(".product-upsell-js"));
if (Shopify.designMode) {
  document.addEventListener("shopify:section:load", () => {
    new ProductUpsell(qs(".product-upsell-js"));
  });
}
